// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorSiteAccountUpsearchModelResponse {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorSiteAccountUpsearchModelResponse.attributeTypeMap;
    }
}
EnterpriseCoordinatorSiteAccountUpsearchModelResponse.discriminator = undefined;
EnterpriseCoordinatorSiteAccountUpsearchModelResponse.additionalProperties = false;
EnterpriseCoordinatorSiteAccountUpsearchModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnterpriseCoordinatorSiteAccountUpsearchResponseModel"
    },
];
//# sourceMappingURL=enterpriseCoordinatorSiteAccountUpsearchModelResponse.js.map